module.exports = __webpack_public_path__ + "static/media/鹽酥雞.57020cb5.jpg";